import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, AfterViewInit, OnDestroy
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl
} from '@angular/forms';

import {
  MAT_DIALOG_DATA, MatDialogRef, MatSnackBar
} from '@angular/material';
import * as moment from 'moment';
import {HttpParams} from '@angular/common/http';
import {UserContext} from '../../../../services/user-context';
import {ApiService} from '../../../../services/api';
import {RemoveEvent} from '@progress/kendo-angular-grid';


@Component({
  selector: 'app-commission-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'commission-dialog.template.html',
  styles: [
    "app-commission-dialog mat-dialog-container {padding:0;}",
    "app-commission-dialog mat-dialog-content.mat-dialog-content {background:#f7fafc;padding:24px;}",
    "app-commission-dialog mat-dialog-actions {display:flex;flex-direction: row;justify-content: space-between;}",
  ]
})

export class CommissionDialogComponent implements OnInit, OnDestroy {
  public form: FormGroup;

  users: any[];
  user_commissions:any[];
  account_commissions:any;
  sales_commissions:any;

  constructor(private formBuilder: FormBuilder,
              private snackBar: MatSnackBar,
              private userContext: UserContext,
              private api: ApiService,
              public dialogRef: MatDialogRef<CommissionDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {


    //console.log("Current commissions: " + JSON.stringify(this.userContext.account.account_commissions,null,4));
    this.account_commissions = this.userContext.account.account_commissions || {commission:0.20, distributor_commission:0.15};
    this.sales_commissions = this.userContext.account.sales_commissions || {default_commission: 0.05};

    //this.user_commissions = this.sales_commissions || [];

    this.api.get<any[]>('/user', new HttpParams().set('account', this.userContext.account.id).set('provider', 'true'))
      .subscribe(result => {
        this.users = result.filter(u => u.firstName && u.lastName);

        this.user_commissions = ((this.sales_commissions || {}).user_commissions || []).map(uc => {
          let user = this.users.filter(u => u.user_id === uc.user_id).shift();
          if( user )
            uc.name = `${user.firstName} ${user.lastName}`;
          return uc;
        })
      });

  }

  public ngOnInit(): void {
    if( this.userContext.hasRole('administrator')) {
      this.form = this.formBuilder.group({
        account_commission: new FormControl(Math.floor(this.account_commissions.commission * 100.0), [
        ]),
        distributor_commission: new FormControl(Math.floor(this.account_commissions.distributor_commission * 100.0), [
        ]),
        default_commission: new FormControl(Math.floor(this.sales_commissions.default_commission * 100.0), [
        ]),
        user_commission: new FormControl(0.00, [
        ]),
        user_id: new FormControl('', [
        ])
      });
    } else {
      this.form = this.formBuilder.group({
        user_commission: new FormControl(0.00, [
        ]),
        default_commission: new FormControl(Math.floor(this.sales_commissions.default_commission * 100.0), [
        ]),
        user_id: new FormControl('', [
        ])
      });
    }
  }

  public onRemove(event: RemoveEvent) {
    this.user_commissions.splice(event.rowIndex, 1);
  }

  public ngOnDestroy(): void {
  }

  public saveUser(): void {
    let user = this.users.filter(u => u.user_id === this.form.value.user_id).shift();
    if( user ) {
      this.user_commissions = this.user_commissions.filter(uc => uc.user_id !== this.form.value.user_id).concat({
        commission: this.form.value.user_commission / 100.0,
        user_id: this.form.value.user_id,
        name:`${user.firstName} ${user.lastName}`
      });
    }
  }

  public save() {
    if( this.userContext.hasRole('administrator')) {
      this.account_commissions.commission = this.form.value.account_commission/100.0;
      this.account_commissions.distributor_commission = this.form.value.distributor_commission/100.0;

      this.sales_commissions.default_commission = this.form.value.default_commission/100.0;
      this.sales_commissions.user_commissions = this.user_commissions;

      this.dialogRef.close({
        account_commissions: this.account_commissions,
        sales_commissions: this.sales_commissions
      })
    } else {
      this.sales_commissions.default_commission = this.form.value.default_commission/100.0;
      this.sales_commissions.user_commissions = this.user_commissions;

      this.dialogRef.close({
        sales_commissions: this.sales_commissions
      })
    }
  }

  public cancel() {
    this.dialogRef.close();
  }
}
